import { call } from 'redux-saga/effects';

import { loadCachedUser } from './auth/auth.saga-services';

// export function* initialize() {
//   const expiredToken = (yield call(logOutIfUserExpired)) as boolean;
//   if (!expiredToken) {
//     yield call(loadCachedUser);
//   }
// }

export function* initialize() {
  yield call(loadCachedUser);
}
